<section>
  <button nz-button [disabled]="isUploading || noImages" (click)="sort.emit()">
    {{ 'SORT' | translate }}
  </button>
</section>

<section>
  <app-lot-add-photo-uploading-list
    [initialImages]="initialImages"
    [noAuctionList]="noAuctionList"
    [grid]="grid"
    [itemHeightPx]="itemHeightPx"
    (images)="imageChanges($event)"
    (uploading)="uploadingStateChange($event)"
  ></app-lot-add-photo-uploading-list>
</section>
